<template>
	<div class="cotent_our">
		<div class="content_top">
			<img src="@/assets/images/our/banner.jpg" alt="" class="w100">
			<!-- <h3>Our Responsibility</h3> -->
		</div>
		<div class="content_center">
			<div class="container">
				<h3>Безопасность превыше всего</h3>
			</div>
			<div class="text_nr_box">
				<div class="text_nr">
					<h4>Безопасность на рабочем месте - наш главный приоритет!</h4>
					<p class="xbt">Безопасность на рабочем месте - наш главный приоритет. Компания Hisan всегда проводила тренинги по безопасному труду и обучала наших сотрудников навыкам безопасного труда, контролю и методам работы. Мы стремимся поддерживать безопасную и здоровую рабочую среду.</p>
				</div>
				<img src="@/assets/images/our/img1.jpg" alt="" class="img1"/>
			</div>	
		</div>
		<div class="content_bottom">
			<div class="container">
				<h3>Социальная ответственность</h3>
			</div>
			<div class="text_nr_box">
				
				<img src="@/assets/images/our/img2.jpg" alt="" class="img1"/>
				<div class="text_nr">
					<h4>Экологически чистое производство</h4>
					<p class="xbt">Литейные возвраты, изношенные детали и забракованные отливки переплавляются для получения новых компонентов. Это позволяет эффективно использовать сырье и при этом гарантировать высокое качество всей продукции Hisan.</p>
					<h4>Обеспечение устойчивого экологического развития</h4>
					<p class="xbt">Наши материалы и системные решения обеспечивают защиту стальных деталей и продлевают срок службы установок и оборудования. Это позволяет более экономно и экологично расходовать ресурсы и помогает нашим заказчикам снижать затраты и работать более эффективно.</p>
				
				</div>
			</div>
			<div class="container">
				<p class="des">Как специалисты по системным решениям, мы помогаем операторам и производителям минимизировать износ везде, где он возникает. Мы продлеваем срок службы стальных быстроизнашивающихся компонентов, создавая тем самым прочную основу для долгосрочной эксплуатации.</p>
			</div>
		</div>
		
	</div>
</template>

<script>
	export default {
		data() {
			return {
			}
		}
	}
</script>

<style scoped lang="scss">
    .cotent_our{
        .content_center{
        	width:100%;
        	h3{font-size: 48px;color: #0c4fa2;margin: 4vw 0 2.5vw;text-align: left;
        		position: relative;line-height: 1.8;
        		&::after{
        			content: '';
        			border-bottom: solid 4px #0c4fa2;width: 120px;position: absolute;bottom: 0;left:0;
        		}
        	}
        	.text_nr_box{
        		background: #0c4fa2;display: flex;
        		.text_nr_box{width: 50%;}
        		.text_nr{color:#fff;width: 32.045%;margin-left: calc(27.1% / 2);margin-right: 5%;
        		display: flex;flex-direction: column;justify-content: center;}
        		h4{font-size: 24px;margin-bottom:16px;}
        		p{font-size: 16px;line-height: 2;
        			
        		}
        		@media (max-width: 1400px) {
        		   h4{font-size: 20px;margin-bottom:10px;}
        		   p{font-size: 14px;line-height: 2;
        		   	
        		   }
        		}
        		img{width: 50%;}
        	}
        	
        }
        .content_bottom{
        	position: relative;background: #e4f0fa;
        	
        	h3{font-size: 48px;color: #0c4fa2;padding: 4vw 0 0vw;margin-bottom: 2.5vw;
        		text-align: center;
        		position: relative;line-height: 1.8;
        		&::after{
        			content: '';
        			border-bottom: solid 4px #0c4fa2;width: 120px;position: absolute;bottom: 0;left:0;
        		}
        	}
        	.text_nr_box{
        		display: flex;
        		.text_nr_box{width: 50%;}
        		.text_nr{width: 32.045%;margin-right: calc(27.1% / 2);margin-left: 5%;
        		display: flex;flex-direction: column;justify-content: center;}
        		h4{font-size: 24px;margin-bottom:16px;color:#333;line-height: 1.8;}
        		p{font-size: 16px;line-height: 2;color:#666;margin-bottom: 30px;
        			
        		}
        		@media (max-width: 1400px) {
        		   h4{font-size: 20px;margin-bottom:10px;}
        		   p{font-size: 14px;line-height: 2;margin-bottom: 20px;
        		   	
        		   }
        		}
        		img{width: 50%;}
        	}
        	.des{font-size:16px;color: #666;line-height: 2;margin: 0;padding: 3vw 0 4vw;text-align: center;
        		@media (max-width: 1400px) {
        		   font-size: 14px;text-align: canvas;
        		}
        	}
        }
        
    }
	
</style>